<template>
    <div class="icon_config chartConfig_viewDP">
        <div class="chartDivConfig checkViewConfig" v-if="config.type==='ellipse'">
            <el-checkbox v-model="config.lockScale" @change="getRender">锁定长宽</el-checkbox>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">填充颜色</span>
            <el-color-picker v-model="config.fillColor" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig " v-if="config.type==='ellipse'">
            <span class="span_til">填充占比</span>
            <el-input v-model="config.proportion" @change="getRender" type="number" min="0.1"  max="1" step="0.1"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">描边颜色</span>
            <el-color-picker v-model="config.strokeColor" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">描边粗细</span>
            <el-input v-model="config.strokeWidth" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">px</div>
        </div>

    </div>
</template>

<script>
    /**
     @author xiaoye0
     @date 2020/4/24 8:04 下午
     */
    import iconList from "../../../iocnfont/iconClass";
    export default {

        name: 'icon_config',
        components: {},
        data() {
            return {
                iconList:iconList.iconList
            }
        },
        computed: {
            config() {
                return this.$store.state.designer.chart.setting.params;
            },
            groupDpList() {
                if (this.type === 'screen') {
                    return this.$store.state.designer.groupDpList
                }
            },
        },
        methods: {
            getRender() {
                this.$store.dispatch('screenRender');
            },
        },
        mounted() {
        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    @import "../../../iocnfont/iconfont.css";

    .icon_config {
        .el-select-dropdown__item {
            display: inline-block;
            width: 24%;
            text-align: center;
        }
    }
    .el-dropdown-menu{
        height: 300px !important;
        width: 305px !important;
        overflow: auto;
        overflow-x: hidden;
        >li{
            display: inline-block;
            width: 40px;
            padding: 0;
            text-align: center;
            >i{
                margin: 0;
            }
        }
    }

</style>
